import { storageKeys } from '../constants';
import axios, { isAxiosError } from 'axios';
import { EUserProvider } from '../types';
import { clearStorage } from '../utils';

const isDevelopment = process.env.NODE_ENV === 'development';

const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL ?? '').replace(
  /\/$/,
  '',
);
const defaultParams = isDevelopment
  ? undefined
  : { provider: EUserProvider.MALE_APPLICATION };

axios.defaults.baseURL = apiBaseUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.params = defaultParams;

// Public surveys authenticate with the survey token in the request body. Keep
// them isolated from the chat token and its global 401 session handling below.
export const publicSurveyAxios = axios.create({
  baseURL: apiBaseUrl,
  headers: { 'Content-Type': 'application/json' },
  params: defaultParams,
});

// request interceptor
axios.interceptors.request.use((config) => {
  const accessToken: string | null = localStorage.getItem(
    storageKeys.ACCESS_TOKEN,
  );
  if (accessToken != null) {
    const accessHeader = `Bearer ${accessToken}`;
    if (config.headers != null) {
      config.headers.Authorization = accessHeader;
    }
  }
  return config;
});

// response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if we're on /mem/talkmail (might be in the middle of authentication)
      const isOnTalkmail = window.location.pathname === '/mem/talkmail';

      if (isOnTalkmail) {
        return Promise.reject(error);
      }

      // Only clear storage and redirect if we're not in the middle of authentication
      // Check if we have a token in URL (indicating ongoing auth)
      const hasAuthToken = new URLSearchParams(window.location.search).get(
        'ucode',
      );

      if (!hasAuthToken) {
        clearStorage();
        window.location.href = '/';
      }
    }

    if (isAxiosError(error)) {
      error.message = error.response?.data?.message || error.message;
      error.status = error.response?.status;
    }
    return Promise.reject(error);
  },
);
